export const getErrorMessage = (error: unknown): string => {
  if (!error) return 'Wystąpił błąd. Spróbuj ponownie.';

  const err = error as { message?: string; response?: { status?: number }; name?: string };
  const msg = (err?.message || '').toLowerCase();

  // Network errors
  if (msg.includes('failed to fetch') || msg.includes('network request failed') || msg.includes('networkerror')) {
    return 'Sprawdź połączenie z internetem i spróbuj ponownie.';
  }

  // HTTP status codes (axios / fetch response)
  if (err.response && typeof err.response.status === 'number') {
    switch (err.response.status) {
      case 400:
        return 'Nieprawidłowe dane. Sprawdź formularz i spróbuj ponownie.';
      case 401:
        return 'Sesja wygasła. Zaloguj się ponownie.';
      case 403:
        return 'Nie masz uprawnień do tej operacji.';
      case 404:
        return 'Nie znaleziono żądanych danych.';
      case 409:
        return 'Ten wpis już istnieje.';
      case 500:
        return 'Wystąpił błąd serwera. Spróbuj ponownie za chwilę.';
      case 503:
        return 'Serwis tymczasowo niedostępny. Spróbuj za kilka minut.';
      default:
        return 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.';
    }
  }

  // Validation errors
  if (err.name === 'ValidationError') {
    return 'Wypełnij wszystkie wymagane pola.';
  }

  // Timeout
  if (msg.includes('timeout') || msg.includes('timed out')) {
    return 'Operacja trwa zbyt długo. Sprawdź połączenie i spróbuj ponownie.';
  }

  // Default
  return 'Wystąpił błąd. Spróbuj ponownie lub skontaktuj się z pomocą techniczną.';
};

export const validationMessages = {
  required: 'To pole jest wymagane',
  invalidEmail: 'Podaj prawidłowy adres email',
  invalidDate: 'Podaj prawidłową datę',
  invalidTime: 'Podaj prawidłowy czas',
  minLength: (min: number) => `Minimum ${min} znaków`,
  maxLength: (max: number) => `Maksimum ${max} znaków`,
  minValue: (min: number) => `Wartość nie może być mniejsza niż ${min}`,
  maxValue: (max: number) => `Wartość nie może być większa niż ${max}`,
  futureDate: 'Data nie może być z przyszłości',
  pastDate: 'Data nie może być z przeszłości',
};
